import { render, staticRenderFns } from "./ViewAppraisal.vue?vue&type=template&id=26629dbc&"
import script from "./ViewAppraisal.vue?vue&type=script&lang=js&"
export * from "./ViewAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports